<template>
  <div :id="id" class="content" :style="`height: ${curHeight}`">
    <div class="content-box">
      <div class="box" @mouseleave="mouseLeave">
        <div class="box-item">
          <img src="../../../assets/images/overseas_service_abroad.png">
          <p class="p-style">{{resource["RES94D330740727043"]}}</p>
          <p class="p-style">
            <span v-for="item in abroadServiceInfo" :key="item.moduleCode" style="margin: 0 5px;" @click="
              navDetailByContentCode(resource['RES94D330740727043'], item)" @mouseenter="mouseOver(item, '775px')">{{ item.moduleName }}</span>
          </p>
        </div>
        <div v-for="item in abroadServiceInfo" :key="item.moduleCode">
          <div class="hover-content img-percent-max hover-overseas"
               v-if="mouseModuleCode === item.moduleCode"
               v-bind:style="{  width: 1140 + 'px'}">
               
            <div class="hover-box design-html" v-bind:style="{ '--beforeLeft': 63 + 'px', '--afterLeft': 62 + 'px'}"
                 v-html="removeHtmlStyle(moduleAbroadServiceMap[item.contentCode])"
                 style="font-size: 16px; line-height: 28px; text-indent: 10px; text-align: justify;">
            </div>
            <div class="more" @click="navDetailByContentCode(resource['RES94D330740727043'], item)">
              显示更多
              <a-icon type="down" style="color: #cab484"/>
            </div>
          </div>
        </div>
      </div>
      <div class="box" @mouseleave="mouseLeave">
        <div class="box-item">
          <img src="../../../assets/images/overseas_service_air_ticketing.png">
          <p class="p-style">{{resource["RES95C5D5C79C77E60"]}}</p>
          <p class="p-style">
            <span v-for="item in airTicketServiceInfo" :key="item.moduleCode" style="margin: 0 5px;"
                  @click="navDetailByContentCode(resource['RES95C5D5C79C77E60'], item)"
                  @mouseenter="mouseOver(item, '755px')">{{ item.moduleName }}</span>
          </p>
        </div>
        <div v-for="item in airTicketServiceInfo" :key="item.moduleCode">
          <div class="hover-content hover-ticket"
               v-if="mouseModuleCode === item.moduleCode"
               v-bind:style="{ left: -235+'px', width: 1140 + 'px' }">
            <div class="hover-box design-html" v-bind:style="{ '--beforeLeft': 343 + 'px', '--afterLeft': 342 + 'px' }"
                 style="font-size: 16px; line-height: 28px; text-indent: 3px; text-align: justify;"
                 v-html="removeHtmlStyle(moduleAirTicketServiceMap[item.contentCode])">
            </div>
            <div class="more" @click="navDetailByContentCode(resource['RES95C5D5C79C77E60'], item)">
              显示更多
              <a-icon type="down" style="color: #cab484"/>
            </div>
          </div>
        </div>
      </div>
      <div class="box" @mouseleave="mouseLeave">
        <div class="box-item">
          <img src="../../../assets/images/overseas_service_apec.png">
          <p class="p-style">{{resource["RES50CF1E25C856297"]}}</p>
          <p class="p-style">
            <span v-for="item in businessTravelCardInfo" :key="item.moduleCode" style="margin: 0 5px;"
                  @click="navBusinessTravelCard('APEC商务旅行卡', item)"
                  @mouseenter="mouseOver(item, 'announce' === item.moduleClass?'775px':'280px')">{{ item.moduleName }}</span>
            <!--            <span style="margin: 0 5px;"-->
            <!--                  @click="pushRouter(`/selfComponents?name=APEC商务旅行卡&linkname=APEC商务旅行卡/内容简介/详情&type=4`)"-->
            <!--                  @mouseenter="mouseOver('apec-services','803px')">内容简介</span>-->
            <!--            <span style="margin: 0 5px;" @click="_getNetService">网上服务</span>-->
          </p>
        </div>
        <div v-for="item in businessTravelCardInfo" :key="item.moduleCode">
          <div class="hover-content hover-APEC"
               v-if="mouseModuleCode === item.moduleCode && moduleBusinessTravelCardMap[item.moduleCode].length"
               v-bind:style="{ left: -464+'px', width: 1140 + 'px' }">
            <div class="hover-box" v-bind:style="{ '--beforeLeft': 553 + 'px', '--afterLeft': 552 + 'px'}">
              <div class="english-name">
                <div v-for="subItem in moduleBusinessTravelCardMap[item.moduleCode]" :key="subItem.contentCode"
                     class="sbox tab" @mouseenter="() => changeTag(subItem)"
                     :style="
                  subItem.contentCode === targetCode
                  && 'border-bottom: 2px solid rgba(203, 180, 134, 1); color: #000;'
                ">
                  {{ subItem.typeName }}
                </div>
              </div>
              <div class="hover-box design-html" v-html="removeHtmlStyle(targetContentHtml)"
                   style="font-size: 16px; line-height: 28px; text-indent: 20px; text-align: justify">
              </div>
              <div class="more" @click="pushRouter(`/selfComponents?name=${resource['RES50CF1E25C856297']}&linkname=${resource['RES50CF1E25C856297']}/内容简介/详情&type=4`)">
                显示更多
                <a-icon type="down" style="color: #cab484"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box" @mouseleave="mouseLeave">
        <div class="box-item">
          <img src="../../../assets/images/overseas_service_consular_protection.png">
          <p class="p-style">{{resource["RESF63620741914636"]}}</p>
          <p class="p-style">
            <span style="margin: 0 5px;" @click="_getSave" @mouseenter="mouseOver('','280px')">海外领事保护信息</span>
            <span></span>
          </p>
        </div>
      </div>
      <div class="box" @mouseleave="mouseLeave">
        <div class="box-item">
          <img src="../../../assets/images/overseas_service_different_countries.png">
          <p  class="p-style">{{resource["RESBCB81EC536DF9E1"]}}</p>
          <p class="p-style">
            <span @click="_getKeys" @mouseenter="mouseOver('','280px')">了解目的地信息</span>
            <span></span>
          </p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {pushContentAnnounceHtmlContent} from "../../../util/navUtils";
import {
  getNetService,
  getSave,
  getNkeys,
  getInfos
} from '@/api/service.js'
import {getInfoByGet, getModuleChild, getModuleInfo,getResource} from "@/api/moduleContent";

export default {
  name: 'hover-box',
  props: {
    id: {
      default: '',
      type: String
    }
  },
  data() {
    return {
      curHeight: '778px', // 280px
      mouseModuleCode: '',
      mouseModuleItem: null,
      abroadServiceInfo: [],
      moduleAbroadServiceMap: {},
      airTicketServiceInfo: [],
      moduleAirTicketServiceMap: {},
      businessTravelCardInfo: [],
      moduleBusinessTravelCardMap: {},
      targetCode: '',
      targetContentHtml: '',
      resource:{}
    }
  },
  created() {
    this.getResource()
    this.mouseModuleCode = this._.get(this, '$route.query.m', '')
    this.curHeight = this._.get(this, '$route.query.h', '280px')
    // this.getList()
    // this.changeTag('1')
    // this.getContent()
    
    this.getAbroadService();
    this.getAirTicketService();
    this.getBusinessTravelCard();
  },
  methods: {
    getResource(){
      getResource("RESC621EF2B6C36966").then(res=>{

        res.data.records&&res.data.records.forEach(e=>{
          // 境外服务
          if(e.resourceCode === "RES94D330740727043"){
            this.resource["RES94D330740727043"] = e.resourceName
          }
          // 航空票务
          if(e.resourceCode === "RES95C5D5C79C77E60"){
            this.resource["RES95C5D5C79C77E60"] = e.resourceName
          }
          // APEC
          if(e.resourceCode === "RES50CF1E25C856297"){
            this.resource["RES50CF1E25C856297"] = e.resourceName
          }
          // 领事保护
          if(e.resourceCode === "RESF63620741914636"){
            this.resource["RESF63620741914636"] = e.resourceName
          }
          // 国别概况
          if(e.resourceCode === "RESBCB81EC536DF9E1"){
            this.resource["RESBCB81EC536DF9E1"] = e.resourceName
          }
        })
      })
    },
    getAbroadService() {
      getModuleInfo('RES94D330740727043').then((res) => {
        this.abroadServiceInfo = [];
        let enterpriseChildArr = res.data.records.map((item) => {
          this.abroadServiceInfo.push({...item});
          return getModuleChild(item.moduleCode, 'contentNews');
        })
        return Promise.all(enterpriseChildArr)
      }).then((arr) => {
        const enterpriseChildInfoArr = arr.map(item => {
          const {contentCode, moduleCode} = item.data.records[0];
          this.abroadServiceInfo.forEach((val) => {
            if (val.moduleCode === moduleCode) {
              val['contentCode'] = contentCode;
            }
          })
          return getInfoByGet(contentCode, 'contentNews');
        })
        return Promise.all(enterpriseChildInfoArr)
      }).then((datas) => {
        for (let res of datas) {
          const {contentHtml, contentCode, contentTitle} = res.data;
          this.abroadServiceInfo.forEach((val) => {
            if (val.contentCode === contentCode) {
              val['contentTitle'] = contentTitle;
            }
          })
          this.$set(this.moduleAbroadServiceMap, contentCode, contentHtml)
        }
      })
    },
    getAirTicketService() {
      getModuleInfo('RES95C5D5C79C77E60').then((res) => {
        this.airTicketServiceInfo = [];
        let enterpriseChildArr = res.data.records.map((item) => {
          this.airTicketServiceInfo.push({...item});
          return getModuleChild(item.moduleCode, 'contentNews');
        })
        return Promise.all(enterpriseChildArr)
      }).then((arr) => {
        const enterpriseChildInfoArr = arr.map(item => {
          const {contentCode, moduleCode} = item.data.records[0];
          this.airTicketServiceInfo.forEach((val) => {
            if (val.moduleCode === moduleCode) {
              val['contentCode'] = contentCode;
            }
          })
          return getInfoByGet(contentCode, 'contentNews');
        })
        return Promise.all(enterpriseChildInfoArr)
      }).then((datas) => {
        for (let res of datas) {
          const {contentHtml, contentCode, contentTitle} = res.data;
          this.airTicketServiceInfo.forEach((val) => {
            if (val.contentCode === contentCode) {
              val['contentTitle'] = contentTitle;
            }
          })
          this.$set(this.moduleAirTicketServiceMap, contentCode, contentHtml)
        }
      })
    },
    getBusinessTravelCard() {
      getModuleInfo('RES50CF1E25C856297').then((res) => {
        this.businessTravelCardInfo = [];
        let enterpriseChildArr = res.data.records.map((item) => {
          this.businessTravelCardInfo.push({...item});
          let contentType = '';
          if ('announce' === item.moduleClass) {
            contentType = 'contentAnnounce';
          } else if ('linkurl' === item.moduleClass) {
            contentType = 'contentLink'
          }
          return getModuleChild(item.moduleCode, contentType);
        })
        return Promise.all(enterpriseChildArr)
      }).then((arr) => {
        this.moduleBusinessTravelCardMap = {}
        const enterpriseChildInfoArr = arr.filter(item => {
          const record = item.data.records[0];
          if (typeof record.linkCode === "string") {
            this.moduleBusinessTravelCardMap[item.params.moduleCode] = record;
            return false;
          }
          return true;
        }).map(item => {
          this.moduleBusinessTravelCardMap[item.data.records[0].moduleCode] = [];
          let contentList = this.moduleBusinessTravelCardMap[item.data.records[0].moduleCode];
          let recordInfoArr = item.data.records.map((record) => {
            contentList.push(record);
            return getInfoByGet(record.contentCode);
          })
          return recordInfoArr;
        })

        return Promise.all(...enterpriseChildInfoArr)
      }).then(datas => {
        const objValues = Object.values(this.moduleBusinessTravelCardMap);
        for (let res of datas) {
          const {contentHtml, contentCode} = res.data;
          for (let value of objValues) {
            if (value.length) {
              value.find((item) => {
                if (item.contentCode === contentCode) {
                  item['contentHtml'] = contentHtml;
                  return true;
                }
              })
            }
          }
        }

        objValues.find((item) => {
          if (item.length) {
            this.targetCode = item[0].contentCode;
            this.targetContentHtml = item[0].contentHtml;
          }
        })
      })
    },
    navDetailByContentCode(parentName, moduleItem) {
      let contentType = 'contentAnnounce';
      if (moduleItem.moduleClass === 'news') {
        contentType = 'contentNews';
      }
       let linkname = `出国服务/${parentName}/${moduleItem.moduleName}`
      pushContentAnnounceHtmlContent(this, moduleItem.contentCode, moduleItem.moduleName, linkname, contentType);
    },
    navBusinessTravelCard(parentName, moduleItem) {
      if (moduleItem.moduleClass === 'linkurl') {
        getNetService().then(res => {
          window.open(this._.get(res, 'data.linkUrl'))
        })
      } else {
        this.pushRouter(`/selfComponents?name=${moduleItem.parentResourceName}&linkname=出国服务/${moduleItem.parentResourceName}/内容简介/详情&type=4`)
      }
    },
    _getSave() {
      getSave().then(res => {
        window.open(this._.get(res, 'data.linkUrl'))
      })
    },
    _getKeys() {
      getNkeys().then(res => {
        window.open(this._.get(res, 'data.linkUrl'))
      })
    },
    // 移入
    mouseOver(moduleItem, height) {
      this.curHeight = height || '720px'
  
      this.mouseModuleCode = moduleItem.moduleCode;
      this.mouseModuleItem = moduleItem;
    },
    // 移出
    mouseLeave() {
      this.curHeight = '280px'
      this.mouseModuleCode = '';
      this.mouseModuleItem = null;
    },
    changeTag(val) {
      this.target = val
      this.targetCode = val.contentCode;
      this.targetContentHtml = val.contentHtml;
      // this[`getApce${val}`]().then(res => {
      //   this.boxData4 = this._.get(res, 'data.contentHtml')
      //   // console.log(this.boxData4);
      // })
    },
    // 清楚文本样式  //不做任何处理  --2023-01-12
    removeHtmlStyle(html) {
      let rel = /style\s*?=\s*?([""])[\s\S]*?\1/;
      let newHtml = "";
      if (html) {
        newHtml = html.replace(rel, "");
      }
      // 清除类名
      // let relClass = /class\s*?=\s*?([‘"])[\s\S]*?\1/g;
      // let newClassHtml = "";
      // if (newHtml) {
      //   newClassHtml = newHtml.replace(relClass, "");
      // }
      return html;
    },
  },
}
</script>

<style scoped lang='less'>
.content {
  width: 100%;
  position: relative;
  margin-top: 40px;

  &-box {
    width: 1140px;
    position: relative;
    margin: auto;
    // left: 50%;
    // transform: translateX(-50%);
    text-align: left;
    font-size: 0px;
  }
}

.box:not(:last-of-type) {
  margin-right: 22px;
}
.design-html img {
  width: 100% ; 
}
.box:hover {
  border: 1px solid #decba4;
  box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
}

.box {
  width: 210px;
  height: 260px;
  display: inline-block;
  border: 1px solid #e5e5e5;
  box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.04);
  text-align: center;
  cursor: default;
  position: relative;

  .box-item {
    position: relative;
    top: 22px;
    width: 210px;
    height: 260px;
  }

  img {
    width: 64px;
    height: 64px;
    margin-top: 39px;
  }

  .service-img {
    width: 100%;
    height: 100%;
    margin-top: 0;
  }

  .p-style {
    margin: 0;
    padding: 0;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    margin-top: 23px;
  }

  .p-style:last-of-type {
    margin-top: 18px;

    span {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #7f7f7f;
      cursor: pointer;
    }

    span:hover {
      color: #cbb486;
    }
  }

  .hover-title {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    margin-top: 20px;
  }

  .hover-title:not(first-of-type) {
    margin-top: 10px;
  }

  .hover-desc {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #3a3a3a;
  }
}

.hover-content {
  width: 1140px;
  /* height: 516px; */
  height: 530px;
  overflow: hidden;
  // white-space: nowrap;
  // display: -webkit-box;
  // -webkit-box-orient: vertical;
  // -webkit-line-clamp: 7;
  position: absolute;
  top: 281px;
  left: 0px;
  display: flex;
  justify-content: space-between;
  padding: 30px;
  border: 1px solid #decba4;
  box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
  font-family: Calibri;
}
.hover-ticket{
  height: 485px;
}
.hover-overseas{
  height: 485px;
}
.hover-APEC{
  height: 485px;
}
.hover-content > p {
  text-align: justify;
}

.img-percent-max /deep/ img {
  width: 100% !important;
}

.hover-box {
  flex: 1;
  // text-align: left;
  text-align: justify;

  // p {
  //   padding: 0;
  //   margin: 0;
  //   padding-bottom: 15px;
  // }

  div:hover {
    // color: #cbb486;
  }

  div.hover-vox:hover {
    color: #3d4652;
  }

  div:hover .down-btn {
    display: inline-block;
  }
}

// .hover-box:first-of-type {
//   // margin-right: 40px;
// }

.down-btn {
  display: inline-block;
  display: none;
  width: 100px;
  height: 40px;
  border-radius: 20px;
  background: #ffffff;
  border: 1px solid #cbb486;
  vertical-align: middle;
  text-align: center;

  img {
    width: 16px;
    height: 16px;
  }
}

.more {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #cab484;
  position: absolute;
  display: block;
  height: 70px;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  background: white;
  width: 100%;
  line-height: 70px;
  text-align: center;
  // opacity: 0.8;
}

.hover-box::before {
  box-sizing: content-box;
  width: 0px;
  height: 0px;
  position: absolute;
  top: -16px;
  left: var(--beforeLeft);
  padding: 0;
  border-bottom: 8px solid #ffffff;
  border-top: 8px solid transparent;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  display: block;
  content: "";
  z-index: 120000000;
}

.hover-box::after {
  box-sizing: content-box;
  width: 0px;
  height: 0px;
  position: absolute;
  top: -18px;
  //left:142px;
  left: var(--afterLeft);
  padding: 0;
  border-bottom: 9px solid #cbb486;
  border-top: 9px solid transparent;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  display: block;
  content: "";
  z-index: 10;
}

.english-name {
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #faf5f5;
  position: relative;
  margin-bottom: 18px;

  > div {
    display: inline-block;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #bcbec0;
    cursor: pointer;
  }

  > div:not(:last-of-type) {
    margin-right: 30px;
  }
}

// .design-html {
//   white-space: pre-wrap;
// }
</style>



// WEBPACK FOOTER //
// src/components/home/serviceAbroad/siderContent-01.vue